// extracted by mini-css-extract-plugin
module.exports = {"MassInfo":"MassInfo_MassInfo__xIuqZ"};